export default __webpack_public_path__ + "static/media/team.917072ad.png";